import { Box, Container, Tab, Tabs } from "@mui/material";
import React, { useState, useEffect } from "react";
import Intro from "./Intro";
import Betrokkene from "./Betrokkene";
import FinancialHistory from "./FinancialHistory";
import FinancialnaOngeval from "./FinancialnaOngeval";
import Rekendeel from "./Rekendeel";
import Voorschot from "./Voorschot";
import PrintDocument from "./PrintDocument";
import { useRef } from "react";
import { yr2026 } from "../tax/tax2026";
import { yr2025 } from "../tax/tax2025";
import { yr2024 } from "../tax/tax2024";
import { yr2023 } from "../tax/tax2023";
import { yr2022 } from "../tax/tax2022";
import { yr2021 } from "../tax/tax2021";
import { yr2020 } from "../tax/tax2020";

export default function TabNav(props) {
    const componentRef = useRef();
    const [mainTabIndex, setMainTabIndex] = useState(0);

    const handleMainTabChange = (e, tabIndex) => {
        setMainTabIndex(tabIndex);
    };

    const today = new Date();
    const defaultDate = today.toISOString().slice(0, 10);

    const calculationSlabs = {
        zelfstandigenaftrek: {
            yr2026: yr2026.zelfstandigenaftrek,
            yr2025: yr2025.zelfstandigenaftrek,
            yr2024: yr2024.zelfstandigenaftrek,
            yr2023: yr2023.zelfstandigenaftrek,
            yr2022: yr2022.zelfstandigenaftrek,
            yr2021: yr2021.zelfstandigenaftrek,
            yr2020: yr2020.zelfstandigenaftrek,
        },
        startersaftrek: {
            /* Cannot be negative */
            yr2026: yr2026.startersaftrek,
            yr2025: yr2025.startersaftrek,
            yr2024: yr2024.startersaftrek,
            yr2023: yr2023.startersaftrek,
            yr2022: yr2022.startersaftrek,
            yr2021: yr2021.startersaftrek,
            yr2020: yr2020.startersaftrek,
        },
        mkbVrijstelling: {
            yr2026: yr2026.mkbVrijstelling,
            yr2025: yr2025.mkbVrijstelling,
            yr2024: yr2024.mkbVrijstelling,
            yr2023: yr2023.mkbVrijstelling,
            yr2022: yr2022.mkbVrijstelling,
            yr2021: yr2021.mkbVrijstelling,
            yr2020: yr2020.mkbVrijstelling,
        },
        zvwBijdrage: {
            yr2026: yr2026.zvwBijdrage,
            yr2025: yr2025.zvwBijdrage,
            yr2024: yr2024.zvwBijdrage,
            yr2023: yr2023.zvwBijdrage,
            yr2022: yr2022.zvwBijdrage,
            yr2021: yr2021.zvwBijdrage,
            yr2020: yr2020.zvwBijdrage,
        },
        arbeidskorting: {
            yr2026: yr2026.arbeidskorting,
            yr2025: yr2025.arbeidskorting,
            yr2024: yr2024.arbeidskorting,
            yr2023: yr2023.arbeidskorting,
            yr2022: yr2022.arbeidskorting,
            yr2021: yr2021.arbeidskorting,
            yr2020: yr2020.arbeidskorting,
        },
        belasting: {
            yr2026: yr2026.belasting,
            yr2025: yr2025.belasting,
            yr2024: yr2024.belasting,
            yr2023: yr2023.belasting,
            yr2022: yr2022.belasting,
            yr2021: yr2021.belasting,
            yr2020: yr2020.belasting,
        },
        heffingskorting: {
            yr2026: yr2026.heffingskorting,
            yr2025: yr2025.heffingskorting,
            yr2024: yr2024.heffingskorting,
            yr2023: yr2023.heffingskorting,
            yr2022: yr2022.heffingskorting,
            yr2021: yr2021.heffingskorting,
            yr2020: yr2020.heffingskorting,
        },
        inkomenhoogsteschaal: {
            yr2026: yr2026.inkomenhoogsteschaal,
            yr2025: yr2025.inkomenhoogsteschaal,
            yr2024: yr2024.inkomenhoogsteschaal,
            yr2023: yr2023.inkomenhoogsteschaal,
            yr2022: yr2022.inkomenhoogsteschaal,
            yr2021: yr2021.inkomenhoogsteschaal,
            yr2020: yr2020.inkomenhoogsteschaal,
        },
        tarrifaanpassing: {
            yr2026: yr2026.tarrifaanpassing,
            yr2025: yr2025.tarrifaanpassing,
            yr2024: yr2024.tarrifaanpassing,
            yr2023: yr2023.tarrifaanpassing,
            yr2022: yr2022.tarrifaanpassing,
            yr2021: yr2021.tarrifaanpassing,
            yr2020: yr2020.tarrifaanpassing,
        }
    }

    const month = [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei.",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ];

    const opmerking = {
        positiveGeschikt: "berekening kan gemaakt worden",
        negativeGeschikt: "deze rechtsvorm wordt niet ondersteund",
        positiveOpmerking: "omzet tot incident ligt in lijn met wat verwacht mag worden",
        negativeOpmerking: "het lijkt erop dat de omzet ook zonder ongeval tenminste 10% lager zou zijn uitgevallen",
    }

    const [betrokkene, setBetrokkene] = useState({
        kenmerk: "Kenmerk",
        email: "Email",
        naam: "Naam",
        naamOnderneming: "Naam Onderneming",
        geboorteDatum: defaultDate,
        ongevalDatum: defaultDate,
        saldibalans: defaultDate,
        rechtvorm: "EMZ",
        jaar: today.getFullYear(),
        jaarMinus1: today.getFullYear() - 1,
        jaarMinus2: today.getFullYear() - 2,
        jaarMinus3: today.getFullYear() - 3,
        aangifteJaarMinus1: true,
        aangifteJaarMinus2: true,
        aangifteJaarMinus3: true,
        totalAangifteJaar: 3,
        resterendMaanden: 0,
        naOngevalMaanden: 0,
        saldibalansPeriod: "jan. t/m " + month[today.getMonth()] + " " + today.getFullYear(),
        verwachtingPeriod: month[today.getMonth() + 1] + " t/m dec. " + today.getFullYear(),
        geschikt: "None",
        opmerking: "None",
        voorschotPerMaand: 0,
        verliesInJaar: 0,
        dataChanged: false,
        voorSchotCalculated: false
    })

    const [financialHistoryMinus1, setFinancialHistoryMinus1] = useState({
        opbrengsten: 0,
        inkoopkosten: 0,
        inhuur: 0,
        bedrijfkosten: 0,
        afscrijvigen: 0,
        batenenlasten: 0,
        arbeidKosten: 0,
        winst: 0,
        premie: 0,
        zelfstandigenaftrek: 0,
        mkbVrijstelling: 0,
        inkomenBox1: 0,
        belasting: 0,
        heffingskorting: 0,
        arbeidskorting: 0,
        inkomenindehoogsteschaal: 0,
        totaalbox1aftrekposten: 0,
        tariefsaanpassing: 0,
        verschuldigdeInkostenBelasting: 0,
        zvwBijdrage: 0,
        nettoJaarInkomen: 0,
        jaarNCI: 0,
        maandNCI: 0,
        maandBruto: 0,
        dataChanged: false,
    })

    const [financialHistoryMinus2, setFinancialHistoryMinus2] = useState({
        opbrengsten: 0,
        inkoopkosten: 0,
        inhuur: 0,
        bedrijfkosten: 0,
        afscrijvigen: 0,
        batenenlasten: 0,
        arbeidKosten: 0,
        winst: 0,
        premie: 0,
        zelfstandigenaftrek: 0,
        mkbVrijstelling: 0,
        inkomenBox1: 0,
        belasting: 0,
        heffingskorting: 0,
        arbeidskorting: 0,
        inkomenindehoogsteschaal: 0,
        totaalbox1aftrekposten: 0,
        tariefsaanpassing: 0,
        verschuldigdeInkostenBelasting: 0,
        zvwBijdrage: 0,
        nettoJaarInkomen: 0,
        jaarNCI: 0,
        maandNCI: 0,
        maandBruto: 0,
        dataChanged: false,
    })

    const [financialHistoryMinus3, setFinancialHistoryMinus3] = useState({
        opbrengsten: 0,
        inkoopkosten: 0,
        inhuur: 0,
        bedrijfkosten: 0,
        afscrijvigen: 0,
        batenenlasten: 0,
        arbeidKosten: 0,
        winst: 0,
        premie: 0,
        zelfstandigenaftrek: 0,
        mkbVrijstelling: 0,
        inkomenBox1: 0,
        belasting: 0,
        heffingskorting: 0,
        arbeidskorting: 0,
        inkomenindehoogsteschaal: 0,
        totaalbox1aftrekposten: 0,
        tariefsaanpassing: 0,
        verschuldigdeInkostenBelasting: 0,
        zvwBijdrage: 0,
        nettoJaarInkomen: 0,
        jaarNCI: 0,
        maandNCI: 0,
        maandBruto: 0,
        dataChanged: false,
    })

    const [financialHistoryAvg, setFinancialHistoryAvg] = useState({
        opbrengsten: 0,
        inkoopkosten: 0,
        inhuur: 0,
        bedrijfkosten: 0,
        afscrijvigen: 0,
        batenenlasten: 0,
        arbeidKosten: 0,
        winst: 0,
        premie: 0,
        zelfstandigenaftrek: 0,
        mkbVrijstelling: 0,
        inkomenBox1: 0,
        belasting: 0,
        heffingskorting: 0,
        arbeidskorting: 0,
        inkomenindehoogsteschaal: 0,
        totaalbox1aftrekposten: 0,
        tariefsaanpassing: 0,
        verschuldigdeInkostenBelasting: 0,
        zvwBijdrage: 0,
        nettoJaarInkomen: 0,
        jaarNCI: 0,
        maandNCI: 0,
        maandBruto: 0,
        dataChanged: false,
    })

    const [saldibalans, setSaldibalans] = useState({
        opbrengsten: 0,
        inkoopkosten: 0,
        inhuur: 0,
        bedrijfkosten: 0,
        afscrijvigen: 0,
        batenenlasten: 0,
        arbeidKosten: 0,
        winst: 0,
        premie: 0,
        zelfstandigenaftrek: 0,
        mkbVrijstelling: 0,
        inkomenBox1: 0,
        belasting: 0,
        heffingskorting: 0,
        arbeidskorting: 0,
        inkomenindehoogsteschaal: 0,
        totaalbox1aftrekposten: 0,
        tariefsaanpassing: 0,
        verschuldigdeInkostenBelasting: 0,
        zvwBijdrage: 0,
        nettoJaarInkomen: 0,
        jaarNCI: 0,
        maandNCI: 0,
        maandBruto: 0,
        dataChanged: false,
    })

    const [verwachting, setVerwachting] = useState({
        opbrengsten: 0,
        inkoopkosten: 0,
        inhuur: 0,
        bedrijfkosten: 0,
        afscrijvigen: 0,
        batenenlasten: 0,
        arbeidKosten: 0,
        winst: 0,
        premie: 0,
        zelfstandigenaftrek: 0,
        mkbVrijstelling: 0,
        inkomenBox1: 0,
        belasting: 0,
        heffingskorting: 0,
        arbeidskorting: 0,
        inkomenindehoogsteschaal: 0,
        totaalbox1aftrekposten: 0,
        tariefsaanpassing: 0,
        verschuldigdeInkostenBelasting: 0,
        zvwBijdrage: 0,
        nettoJaarInkomen: 0,
        jaarNCI: 0,
        maandNCI: 0,
        maandBruto: 0,
        dataChanged: false,
    })

    const [opgeteld, setOpgeteld] = useState({
        opbrengsten: 0,
        inkoopkosten: 0,
        inhuur: 0,
        bedrijfkosten: 0,
        afscrijvigen: 0,
        batenenlasten: 0,
        arbeidKosten: 0,
        winst: 0,
        premie: 0,
        zelfstandigenaftrek: 0,
        mkbVrijstelling: 0,
        inkomenBox1: 0,
        belasting: 0,
        heffingskorting: 0,
        arbeidskorting: 0,
        inkomenindehoogsteschaal: 0,
        totaalbox1aftrekposten: 0,
        tariefsaanpassing: 0,
        verschuldigdeInkostenBelasting: 0,
        zvwBijdrage: 0,
        nettoJaarInkomen: 0,
        jaarNCI: 0,
        maandNCI: 0,
        maandBruto: 0,
        dataChanged: false,
    })

    // const [benchmark, setBenchmark] = useState({
    //     opbrengsten: 0,
    //     inkoopkosten: 0,
    //     inhuur: 0,
    //     bedrijfkosten: 0,
    //     afscrijvigen: 0,
    //     batenenlasten: 0,
    //     arbeidKosten: 0,
    //     winst: 0,
    //     premie: 0,
    //     zelfstandigenaftrek: 0,
    //     mkbVrijstelling: 0,
    //     inkomenBox1: 0,
    //     belasting: 0,
    //     heffingskorting: 0,
    //     arbeidskorting: 0,
    //     inkomenindehoogsteschaal: 0,
    //     totaalbox1aftrekposten: 0,
    //     tariefsaanpassing: 0,
    //     verschuldigdeInkostenBelasting: 0,
    //     zvwBijdrage: 0,
    //     nettoJaarInkomen: 0,
    //     jaarNCI: 0,
    //     maandNCI: 0,
    // })

    function applyCalculationSlabs(amount, slabs) {
        for (const idx in slabs) {
            const s = slabs[idx];
            if (amount >= s.low && amount < s.high) {
                const retValue = s.addition + (amount - s.low) * s.pct / 100;
                return retValue;
            }
        }
    }

    const calculateRekendeel = (financialDetails, jaarCode) => {
        const primie = financialDetails.premie
        // const winst = financialDetails.winst;
        const winst = financialDetails.opbrengsten
            - financialDetails.inkoopkosten
            - financialDetails.inhuur
            - financialDetails.bedrijfkosten
            - financialDetails.arbeidKosten
            - financialDetails.afscrijvigen
            + financialDetails.batenenlasten;

        const zelfstandigenaftrek = calculationSlabs.zelfstandigenaftrek[jaarCode];
        const mbkVrijstelling = (winst - zelfstandigenaftrek) * calculationSlabs.mkbVrijstelling[jaarCode] / 100;
        const inkomenBox1 = winst - zelfstandigenaftrek - mbkVrijstelling - primie;
        const tempHeffingskorting = applyCalculationSlabs(inkomenBox1, calculationSlabs.heffingskorting[jaarCode]);
        const arbeidskorting = applyCalculationSlabs(winst, calculationSlabs.arbeidskorting[jaarCode]);
        const inkomenindehoogsteschaal = Math.max(inkomenBox1 - calculationSlabs.inkomenhoogsteschaal[jaarCode], 0);
        // const inkomenindehoogsteschaal = Math.max(winst - calculationSlabs.inkomenhoogsteschaal[jaarCode], 0);
        const totaalbox1aftrekposten = zelfstandigenaftrek + mbkVrijstelling;
        const tariefsaanpassing = (Math.min(totaalbox1aftrekposten, inkomenindehoogsteschaal) * calculationSlabs.tarrifaanpassing[jaarCode]);
        const belasting = applyCalculationSlabs(inkomenBox1, calculationSlabs.belasting[jaarCode]);
        const heffingskorting = Math.min(tempHeffingskorting, belasting - arbeidskorting);
        const verschuldigdeInkostenBelasting = belasting - heffingskorting - arbeidskorting + tariefsaanpassing;
        const zvwBijdrage = Math.min(inkomenBox1 + primie, calculationSlabs.zvwBijdrage[jaarCode].limit) * calculationSlabs.zvwBijdrage[jaarCode].pct / 100;
        const nettoJaarInkomen = winst - verschuldigdeInkostenBelasting - zvwBijdrage - primie;
        const jaarNCI = nettoJaarInkomen;
        const maandNCI = nettoJaarInkomen / 12;
        const maandBruto = inkomenBox1 / 12;

        financialDetails.winst = winst;
        financialDetails.zelfstandigenaftrek = zelfstandigenaftrek;
        financialDetails.mkbVrijstelling = Math.round(mbkVrijstelling);
        financialDetails.inkomenBox1 = Math.round(inkomenBox1);
        financialDetails.belasting = Math.round(belasting);
        financialDetails.heffingskorting = Math.round(heffingskorting);
        financialDetails.arbeidskorting = Math.round(arbeidskorting);
        financialDetails.inkomenindehoogsteschaal = Math.round(inkomenindehoogsteschaal);
        financialDetails.totaalbox1aftrekposten = totaalbox1aftrekposten;
        financialDetails.tariefsaanpassing = Math.round(tariefsaanpassing);
        financialDetails.verschuldigdeInkostenBelasting = Math.round(verschuldigdeInkostenBelasting);
        financialDetails.zvwBijdrage = Math.round(zvwBijdrage);
        financialDetails.nettoJaarInkomen = Math.round(nettoJaarInkomen);
        financialDetails.jaarNCI = Math.round(jaarNCI);
        financialDetails.maandNCI = Math.round(maandNCI);
        financialDetails.maandBruto = Math.round(maandBruto);
        financialDetails.dataChanged = false

        return financialDetails;
    }

    function calculateRekendeelMinus1() {
        const jaarCode = "yr" + betrokkene.jaarMinus1;
        setFinancialHistoryMinus1({ ...calculateRekendeel(financialHistoryMinus1, jaarCode) });
    }


    function calculateRekendeelMinus2() {
        const jaarCode = "yr" + betrokkene.jaarMinus2;
        setFinancialHistoryMinus2({ ...calculateRekendeel(financialHistoryMinus2, jaarCode) });
    }


    function calculateRekendeelMinus3() {
        const jaarCode = "yr" + betrokkene.jaarMinus3;
        setFinancialHistoryMinus3({ ...calculateRekendeel(financialHistoryMinus3, jaarCode) });
    }

    function calculateRekendeelAvg() {
        const jaarCode = "yr" + betrokkene.jaar;
        setFinancialHistoryAvg({ ...calculateRekendeel(financialHistoryAvg, jaarCode) })
    }

    function calculateRekendeelOpgeteld() {
        const jaarCode = "yr" + betrokkene.jaar;
        setOpgeteld({ ...calculateRekendeel(opgeteld, jaarCode) });
        setOpgeteld({
            ...opgeteld,
            dataChanged: false,
        })
    }

    function calculateVoorschot() {
        const verliesInJaar = financialHistoryAvg.jaarNCI - opgeteld.jaarNCI;
        const voorSchotPerMaand = Math.round(Math.max(0, verliesInJaar) / (12 - betrokkene.resterendMaanden));
        const geschikt = (betrokkene.rechtvorm === "BV") ? opmerking.negativeGeschikt : opmerking.positiveGeschikt;

        const geprojecteerdOmzet = saldibalans.opbrengsten - financialHistoryAvg.opbrengsten * betrokkene.naOngevalMaanden / 12
        const opmerk = (geprojecteerdOmzet * 0.9 < 0) ? opmerking.negativeOpmerking : opmerking.positiveOpmerking;

        setBetrokkene({
            ...betrokkene,
            verliesInJaar: verliesInJaar,
            voorschotPerMaand: voorSchotPerMaand,
            geschikt: geschikt,
            opmerking: opmerk,
            dataChanged: false,
            voorSchotCalculated: true,
        })

    }

    function calculateRekendeelSaldibalans() {
        const jaarCode = "yr" + betrokkene.jaar;
        setSaldibalans({ ...calculateRekendeel(saldibalans, jaarCode) })
    }

    useEffect(() => {
        setFinancialHistoryAvg({
            opbrengsten: Math.round((financialHistoryMinus1.opbrengsten + financialHistoryMinus2.opbrengsten + financialHistoryMinus3.opbrengsten) / betrokkene.totalAangifteJaar),
            inkoopkosten: Math.round((financialHistoryMinus1.inkoopkosten + financialHistoryMinus2.inkoopkosten + financialHistoryMinus3.inkoopkosten) / betrokkene.totalAangifteJaar),
            inhuur: Math.round((financialHistoryMinus1.inhuur + financialHistoryMinus2.inhuur + financialHistoryMinus3.inhuur) / betrokkene.totalAangifteJaar),
            bedrijfkosten: Math.round((financialHistoryMinus1.bedrijfkosten + financialHistoryMinus2.bedrijfkosten + financialHistoryMinus3.bedrijfkosten) / betrokkene.totalAangifteJaar),
            afscrijvigen: Math.round((financialHistoryMinus1.afscrijvigen + financialHistoryMinus2.afscrijvigen + financialHistoryMinus3.afscrijvigen) / betrokkene.totalAangifteJaar),
            batenenlasten: Math.round((financialHistoryMinus1.batenenlasten + financialHistoryMinus2.batenenlasten + financialHistoryMinus3.batenenlasten) / betrokkene.totalAangifteJaar),
            arbeidKosten: Math.round((financialHistoryMinus1.arbeidKosten + financialHistoryMinus2.arbeidKosten + financialHistoryMinus3.arbeidKosten) / betrokkene.totalAangifteJaar),
            inkomenindehoogsteschaal: Math.round((financialHistoryMinus1.inkomenindehoogsteschaal + financialHistoryMinus2.inkomenindehoogsteschaal + financialHistoryMinus3.inkomenindehoogsteschaal) / betrokkene.totalAangifteJaar),
            totaalbox1aftrekposten: Math.round((financialHistoryMinus1.totaalbox1aftrekposten + financialHistoryMinus2.totaalbox1aftrekposten + financialHistoryMinus3.totaalbox1aftrekposten) / betrokkene.totalAangifteJaar),
            tariefsaanpassing: Math.round((financialHistoryMinus1.tariefsaanpassing + financialHistoryMinus2.tariefsaanpassing + financialHistoryMinus3.tariefsaanpassing) / betrokkene.totalAangifteJaar),
            winst: Math.round((financialHistoryMinus1.winst + financialHistoryMinus2.winst + financialHistoryMinus3.winst) / betrokkene.totalAangifteJaar),
            premie: Math.round((financialHistoryMinus1.premie + financialHistoryMinus2.premie + financialHistoryMinus3.premie) / betrokkene.totalAangifteJaar),
            zelfstandigenaftrek: Math.round((financialHistoryMinus1.zelfstandigenaftrek + financialHistoryMinus2.zelfstandigenaftrek + financialHistoryMinus3.zelfstandigenaftrek) / betrokkene.totalAangifteJaar),
            mkbVrijstelling: Math.round((financialHistoryMinus1.mkbVrijstelling + financialHistoryMinus2.mkbVrijstelling + financialHistoryMinus3.mkbVrijstelling) / betrokkene.totalAangifteJaar),
            inkomenBox1: Math.round((financialHistoryMinus1.inkomenBox1 + financialHistoryMinus2.inkomenBox1 + financialHistoryMinus3.inkomenBox1) / betrokkene.totalAangifteJaar),
            belasting: Math.round((financialHistoryMinus1.belasting + financialHistoryMinus2.belasting + financialHistoryMinus3.belasting) / betrokkene.totalAangifteJaar),
            heffingskorting: Math.round((financialHistoryMinus1.heffingskorting + financialHistoryMinus2.heffingskorting + financialHistoryMinus3.heffingskorting) / betrokkene.totalAangifteJaar),
            arbeidskorting: Math.round((financialHistoryMinus1.arbeidskorting + financialHistoryMinus2.arbeidskorting + financialHistoryMinus3.arbeidskorting) / betrokkene.totalAangifteJaar),
            verschuldigdeInkostenBelasting: Math.round((financialHistoryMinus1.verschuldigdeInkostenBelasting + financialHistoryMinus2.verschuldigdeInkostenBelasting + financialHistoryMinus3.verschuldigdeInkostenBelasting) / betrokkene.totalAangifteJaar),
            zvwBijdrage: Math.round((financialHistoryMinus1.zvwBijdrage + financialHistoryMinus2.zvwBijdrage + financialHistoryMinus3.zvwBijdrage) / betrokkene.totalAangifteJaar),
            nettoJaarInkomen: Math.round((financialHistoryMinus1.nettoJaarInkomen + financialHistoryMinus2.nettoJaarInkomen + financialHistoryMinus3.nettoJaarInkomen) / betrokkene.totalAangifteJaar),
            jaarNCI: Math.round((financialHistoryMinus1.jaarNCI + financialHistoryMinus2.jaarNCI + financialHistoryMinus3.jaarNCI) / betrokkene.totalAangifteJaar),
            maandNCI: ((financialHistoryMinus1.maandNCI + financialHistoryMinus2.maandNCI + financialHistoryMinus3.maandNCI) / betrokkene.totalAangifteJaar),
            maandBruto: ((financialHistoryMinus1.maandBruto + financialHistoryMinus2.maandBruto + financialHistoryMinus3.maandBruto) / betrokkene.totalAangifteJaar),
            dataChanged: true,
        });
    }, [financialHistoryMinus1, financialHistoryMinus2, financialHistoryMinus3, betrokkene.totalAangifteJaar])

    // useEffect(() => {
    //     setBetrokkene({
    //         ...betrokkene,
    //         voorSchotCalculated: false,
    //     });
    // }, [betrokkene, financialHistoryMinus1, financialHistoryMinus2, financialHistoryMinus3, saldibalans, opgeteld])

    useEffect(() => {
        setOpgeteld(prev => ({
            ...prev,
            opbrengsten: saldibalans.opbrengsten + verwachting.opbrengsten,
            inkoopkosten: saldibalans.inkoopkosten + verwachting.inkoopkosten,
            inhuur: saldibalans.inhuur + verwachting.inhuur,
            bedrijfkosten: saldibalans.bedrijfkosten + verwachting.bedrijfkosten,
            afscrijvigen: saldibalans.afscrijvigen + verwachting.afscrijvigen,
            batenenlasten: saldibalans.batenenlasten + verwachting.batenenlasten,
            arbeidKosten: saldibalans.arbeidKosten + verwachting.arbeidKosten,
            winst: saldibalans.winst + verwachting.winst,
            premie: saldibalans.premie + verwachting.premie,
        }))
    }, [saldibalans, verwachting])

    const handleBetrokkene = (name, value) => {
        if (["aangifteJaarMinus1", "aangifteJaarMinus2", "aangifteJaarMinus3"].includes(name)) {
            setBetrokkene({
                ...betrokkene,
                [name]: value,
                totalAangifteJaar: betrokkene.aangifteJaarMinus1 + betrokkene.aangifteJaarMinus2 + betrokkene.aangifteJaarMinus3 - betrokkene[name] + value
            });
        } else {
            if (name === "ongevalDatum") {
                const newDate = new Date(value)
                setBetrokkene({
                    ...betrokkene,
                    [name]: value,
                    jaar: newDate.getFullYear(),
                    jaarMinus1: newDate.getFullYear() - 1,
                    jaarMinus2: newDate.getFullYear() - 2,
                    jaarMinus3: newDate.getFullYear() - 3,
                });
            } else {
                if (name === "saldibalans") {
                    const newDate = new Date(value)
                    setBetrokkene({
                        ...betrokkene,
                        [name]: value,
                        resterendMaanden: newDate.getMonth() + 1,
                        naOngevalMaanden: 12 - newDate.getMonth() + 1,
                        saldibalansPeriod: "jan. t/m " + month[newDate.getMonth()] + " " + newDate.getFullYear(),
                        verwachtingPeriod: month[newDate.getMonth() + 1] + " t/m dec. " + newDate.getFullYear(),

                    });
                } else {
                    setBetrokkene({
                        ...betrokkene,
                        [name]: value,
                    });
                }
            }

        }
    }

    const handleFHMinus1 = (event, value) => {
        setFinancialHistoryMinus1({
            ...financialHistoryMinus1,
            [event.target.name]: value,
            dataChanged: true,
            winst: event.target.name === "opbrengsten" || event.target.name === "batenenlasten" ?
                financialHistoryMinus1.opbrengsten
                - financialHistoryMinus1.inkoopkosten
                - financialHistoryMinus1.inhuur
                - financialHistoryMinus1.bedrijfkosten
                - financialHistoryMinus1.arbeidKosten
                - financialHistoryMinus1.afscrijvigen
                + financialHistoryMinus1.batenenlasten
                - financialHistoryMinus1[event.target.name]
                + value :
                financialHistoryMinus1.opbrengsten
                - financialHistoryMinus1.inkoopkosten
                - financialHistoryMinus1.inhuur
                - financialHistoryMinus1.bedrijfkosten
                - financialHistoryMinus1.arbeidKosten
                - financialHistoryMinus1.afscrijvigen
                + financialHistoryMinus1.batenenlasten
                + financialHistoryMinus1[event.target.name]
                - value
        });
        setBetrokkene({
            ...betrokkene,
            voorSchotCalculated: false,
        });
    }

    const handleFHMinus2 = (event, value) => {
        setFinancialHistoryMinus2({
            ...financialHistoryMinus2,
            [event.target.name]: value,
            dataChanged: true,
            winst: event.target.name === "opbrengsten" || event.target.name === "batenenlasten" ?
                financialHistoryMinus2.opbrengsten
                - financialHistoryMinus2.inkoopkosten
                - financialHistoryMinus2.inhuur
                - financialHistoryMinus2.bedrijfkosten
                - financialHistoryMinus2.arbeidKosten
                - financialHistoryMinus2.afscrijvigen
                + financialHistoryMinus2.batenenlasten
                - financialHistoryMinus2[event.target.name]
                + value :
                financialHistoryMinus2.opbrengsten
                - financialHistoryMinus2.inkoopkosten
                - financialHistoryMinus2.inhuur
                - financialHistoryMinus2.bedrijfkosten
                - financialHistoryMinus2.arbeidKosten
                - financialHistoryMinus2.afscrijvigen
                + financialHistoryMinus2.batenenlasten
                + financialHistoryMinus2[event.target.name]
                - value

        });
        setBetrokkene({
            ...betrokkene,
            voorSchotCalculated: false,
        });
    }

    const handleFHMinus3 = (event, value) => {
        console.log(event.target.name);
        setFinancialHistoryMinus3({
            ...financialHistoryMinus3,
            [event.target.name]: value,
            dataChanged: true,
            winst: event.target.name === "opbrengsten" || event.target.name === "batenenlasten" ?
                financialHistoryMinus3.opbrengsten
                - financialHistoryMinus3.inkoopkosten
                - financialHistoryMinus3.inhuur
                - financialHistoryMinus3.bedrijfkosten
                - financialHistoryMinus3.arbeidKosten
                - financialHistoryMinus3.afscrijvigen
                + financialHistoryMinus3.batenenlasten
                - financialHistoryMinus3[event.target.name]
                + value :
                financialHistoryMinus3.opbrengsten
                - financialHistoryMinus3.inkoopkosten
                - financialHistoryMinus3.inhuur
                - financialHistoryMinus3.bedrijfkosten
                - financialHistoryMinus3.arbeidKosten
                - financialHistoryMinus3.afscrijvigen
                + financialHistoryMinus3.batenenlasten
                + financialHistoryMinus3[event.target.name]
                - value
        });
        setBetrokkene({
            ...betrokkene,
            voorSchotCalculated: false,
        });
    }

    const handleSaldibalans = (event, value) => {
        setSaldibalans({
            ...saldibalans,
            [event.target.name]: value,
            dataChanged: true,
            winst: event.target.name === "opbrengsten" || event.target.name === "batenenlasten" ?
                saldibalans.opbrengsten
                - saldibalans.inkoopkosten
                - saldibalans.inhuur
                - saldibalans.bedrijfkosten
                - saldibalans.arbeidKosten
                - saldibalans.afscrijvigen
                + saldibalans.batenenlasten
                - saldibalans[event.target.name]
                + value :
                saldibalans.opbrengsten
                - saldibalans.inkoopkosten
                - saldibalans.inhuur
                - saldibalans.bedrijfkosten
                - saldibalans.arbeidKosten
                - saldibalans.afscrijvigen
                + saldibalans.batenenlasten
                + saldibalans[event.target.name]
                - value
        });
        setOpgeteld({
            ...opgeteld,
            dataChanged: true,
        })
        setBetrokkene({
            ...betrokkene,
            voorSchotCalculated: false,
        });
    }

    const handleVerwachting = (event, value) => {
        setVerwachting({
            ...verwachting,
            [event.target.name]: value,
            dataChanged: true,
            winst: event.target.name === "opbrengsten" || event.target.name === "batenenlasten" ?
                verwachting.opbrengsten
                - verwachting.inkoopkosten
                - verwachting.inhuur
                - verwachting.bedrijfkosten
                - verwachting.arbeidKosten
                - verwachting.afscrijvigen
                + verwachting.batenenlasten
                - verwachting[event.target.name]
                + value :
                verwachting.opbrengsten
                - verwachting.inkoopkosten
                - verwachting.inhuur
                - verwachting.bedrijfkosten
                - verwachting.arbeidKosten
                - verwachting.afscrijvigen
                + verwachting.batenenlasten
                + verwachting[event.target.name]
                - value
        })
        setOpgeteld({
            ...opgeteld,
            dataChanged: true,
        })
        setBetrokkene({
            ...betrokkene,
            voorSchotCalculated: false,
        });
    }

    return (
        <center>
            <div>
                <Box>
                    <Tabs
                        value={mainTabIndex}
                        onChange={handleMainTabChange}
                        textColor="primary"
                        indicatorColor="secondary"
                    >
                        <Tab label="Introductie Uitleg" />
                        <Tab label="Gegevens" />
                        <Tab label="Financiele Historie" />
                        <Tab label="Financiele situatie na Ongeval" />
                        <Tab label="Rekendeel" />
                        <Tab label="Voorschot" disabled={!betrokkene.voorSchotCalculated} />
                        <Tab label="Print Voorschot" disabled={!betrokkene.voorSchotCalculated} />
                    </Tabs>
                    <div>
                        <Container sx={{ overflowY: "scroll", height: "650px", maxHeight: "650px" }}>
                            {/* Introductie uitleg */}
                            {
                                mainTabIndex === 0 && (
                                    <Intro />
                                )
                            }
                            {/* Betrokkene */}
                            {
                                mainTabIndex === 1 && (
                                    <Betrokkene
                                        betrokkene={betrokkene}
                                        updateBetrokkene={handleBetrokkene}
                                    />
                                )
                            }
                            {/* Financiele Historie */}
                            {
                                mainTabIndex === 2 && (
                                    <FinancialHistory
                                        fhMinus1={financialHistoryMinus1}
                                        updateFHMinus1={handleFHMinus1}
                                        calculateRekendeelMinus1={calculateRekendeelMinus1}
                                        fhMinus2={financialHistoryMinus2}
                                        updateFHMinus2={handleFHMinus2}
                                        calculateRekendeelMinus2={calculateRekendeelMinus2}
                                        fhMinus3={financialHistoryMinus3}
                                        updateFHMinus3={handleFHMinus3}
                                        calculateRekendeelMinus3={calculateRekendeelMinus3}
                                        fhAvg={financialHistoryAvg}
                                        calculateRekendeelAvg={calculateRekendeelAvg}
                                        betrokkene={betrokkene}
                                    />
                                )
                            }
                            {/* Financiele na Ongeval */}
                            {
                                mainTabIndex === 3 && (
                                    <FinancialnaOngeval
                                        saldibalans={saldibalans}
                                        updateSaldibalans={handleSaldibalans}
                                        calculateRekendeelSaldibalans={calculateRekendeelSaldibalans}
                                        verwachting={verwachting}
                                        updateVerwachting={handleVerwachting}
                                        opgeteld={opgeteld}
                                        betrokkene={betrokkene}
                                        calculateRekendeelOpgeteld={calculateRekendeelOpgeteld}
                                    />
                                )
                            }
                            {/* Rekendeel */}
                            {
                                mainTabIndex === 4 && (
                                    <Rekendeel
                                        fhMinus1={financialHistoryMinus1}
                                        fhMinus2={financialHistoryMinus2}
                                        fhMinus3={financialHistoryMinus3}
                                        fhAvg={financialHistoryAvg}
                                        saldibalans={saldibalans}
                                        calculateVoorschot={calculateVoorschot}
                                        opgeteld={opgeteld}
                                        betrokkene={betrokkene}
                                    />
                                )
                            }
                            {/* Voorschot */}
                            {
                                mainTabIndex === 5 && (
                                    <Voorschot
                                        betrokkene={betrokkene}
                                    />
                                )
                            }
                            {/* Print Voorschot */}
                            {
                                mainTabIndex === 6 && (
                                    <PrintDocument
                                        fhMinus1={financialHistoryMinus1}
                                        fhMinus2={financialHistoryMinus2}
                                        fhMinus3={financialHistoryMinus3}
                                        fhAvg={financialHistoryAvg}
                                        saldibalans={saldibalans}
                                        opgeteld={opgeteld}
                                        betrokkene={betrokkene}
                                        componentRef={componentRef}
                                    />
                                )
                            }
                        </Container>
                    </div>
                </Box>
            </div>
        </center>
    );

}